import styled from "styled-components";

export const Container = styled.div`
  
`;

export const Formulario = styled.form`
  width: 100%;
`;

export const HelperInput = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-around;

  width: 100%;

  margin-bottom: 2vh;
`;

export const HandleButton = styled.div`
  width: 40%;
  margin-top: 10vh;
  display: flex;
  align-items: center;
  justify-content:space-between;
`;

export const HandleOperationButtons = styled.div`

  width:40%;

`;
export const HandleEditarButton = styled.div`

  width:100%;
  margin-top:2vh;

`;

